import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { FormConfigService } from '../form-config/form-config.service';
import { RoundAndFormatPipe } from '../shared/pipes/round-and-format.pipe';
import { SharedModule } from '../shared/shared.module';
import { UiKitModule } from '../ui-kit/ui-kit.module';
import { AgentsComponent } from './create-product/agents/agents.component';
import { FilterEntitiesPipe } from './create-product/agents/pipes/filter-entities.pipe';
import { CreateProductComponent } from './create-product/create-product.component';
import { CreditProvisionComponent } from './create-product/credit-provision/credit-provision.component';
import { SettlementMethodComponent } from './create-product/credit-provision/settlement-method/settlement-method.component';
import { EventSchedulesComponent } from './create-product/event-schedules/event-schedules.component';
import { KeyDatesDataComponent } from './create-product/event-schedules/key-dates-data/key-dates-data.component';
import { IncrementalErrorMessagePipe } from './create-product/legal-form/incremental-error-message.pipe';
import { LegalFormComponent } from './create-product/legal-form/legal-form.component';
import { PayoffComponent } from './create-product/payoff/payoff.component';
import { DynamicStrikeLabelPipe } from './create-product/payoff/pipes/dynamic-strike-label-pipe.pipe';
import { CallScheduleComponent } from './create-product/payoff/schedule/call-schedule/call-schedule.component';
import { CouponScheduleComponent } from './create-product/payoff/schedule/coupon-schedule/coupon-schedule.component';
import { ParticipationScheduleComponent } from './create-product/payoff/schedule/participation-schedule/participation-schedule.component';
import { RollDaysModalRowComponent } from './create-product/payoff/schedule/roll-days-modal/roll-days-modal-row/roll-days-modal-row.component';
import { RollDaysModalComponent } from './create-product/payoff/schedule/roll-days-modal/roll-days-modal.component';
import { BarrierLevelPipe } from './create-product/payoff/schedule/schedule-row/barrier-level.pipe';
import { IsDirtyPipe } from './create-product/payoff/schedule/schedule-row/is-dirty.pipe';
import { RedemptionAmountPipe } from './create-product/payoff/schedule/schedule-row/redemption-amount.pipe';
import { ScheduleRowComponent } from './create-product/payoff/schedule/schedule-row/schedule-row.component';
import { ScheduleComponent } from './create-product/payoff/schedule/schedule.component';
import { ToggleColumnValidationPipe } from './create-product/payoff/schedule/toggle-column-validation/toggle-column-validation.pipe';
import { PricingComponent } from './create-product/pricing/pricing.component';
import { ProductNotesComponent } from './create-product/product-notes/product-notes.component';
import { DateRowComponent } from './create-product/product-summary/key-dates-modal/date-row/date-row.component';
import { KeyDatesModalComponent } from './create-product/product-summary/key-dates-modal/key-dates-modal.component';
import { ProductSummaryComponent } from './create-product/product-summary/product-summary.component';
import { RecordWorkflowModalComponent } from './create-product/product-summary/record-workflow-modal/record-workflow-modal.component';
import { ReferenceModalModule } from './create-product/product-summary/reference-modal/reference-modal.module';
import { UnderlyingAssetsModalModule } from './create-product/product-summary/underlying-assets-modal/underlying-assets-modal.module';
import { SalesComponent } from './create-product/sales/sales.component';
import { WarningComponent } from './create-product/warning-modal/warning-modal.component';
import { ImportProductComponent } from './import-product/import-product.component';
import { DateToStringPipe } from '../shared/pipes/date-to-string.pipe';
import { DocumentTypePipe } from './pipes/document-type.pipe';
import { FilterContactsPipe } from './pipes/filter-contacts.pipe';
import { SaveButtonLabelPipe } from './pipes/save-button-label.pipe';
import { AnalyticsReportStateComponent } from './product-capture-details/analytics/analytics-report-state/analytics-report-state.component';
import { AnalyticsRequestModalComponent } from './product-capture-details/analytics/analytics-request-modal/analytics-request-modal.component';
import { FilterSourcePipe } from './product-capture-details/analytics/analytics-request-modal/filter-source.pipe';
import { AnalyticsTablesBaseComponent } from './product-capture-details/analytics/analytics-tables-base/analytics-tables-base.component';
import { AnalyticsComponent } from './product-capture-details/analytics/analytics.component';
import { PriipsTablesComponent } from './product-capture-details/analytics/priips-tables/priips-tables.component';
import { RefreshAnalyticsModalComponent } from './product-capture-details/analytics/refresh-analytics-modal/refresh-analytics-modal.component';
import { StressTestingTablesComponent } from './product-capture-details/analytics/stress-testing-tables/stress-testing-tables.component';
import { GovernanceChecksComponent } from './product-capture-details/governance-checks/governance-checks.component';
import { GovernanceTestResultsComponent } from './product-capture-details/governance-checks/governance-test-results/governance-test-results.component';
import { DocumentComparisonComponent } from './product-capture-details/overview/document-comparison/document-comparison.component';
import { CompareModalComponent } from './product-capture-details/overview/documents-tab/compare-modal/compare-modal.component';
import { DocumentMenuComponent } from './product-capture-details/overview/documents-tab/document-menu/document-menu.component';
import { DocumentsTabComponent } from './product-capture-details/overview/documents-tab/documents-tab.component';
import { PreviewModalComponent } from './product-capture-details/overview/documents-tab/preview-modal/preview-modal.component';
import { RequestModalComponent } from './product-capture-details/overview/documents-tab/request-modal/request-modal.component';
import { UploadModalComponent } from './product-capture-details/overview/documents-tab/upload-modal/upload-modal.component';
import { DocumentsComponent } from './product-capture-details/overview/documents/documents.component';
import { OverviewComponent } from './product-capture-details/overview/overview.component';
import { ProductCaptureDetailsComponent } from './product-capture-details/product-capture-details.component';
import { AuditModalComponent } from './product-capture-list/audit-modal/audit-modal.component';
import { AuditModalService } from './product-capture-list/audit-modal/audit-modal.service';
import { ProductCaptureListComponent } from './product-capture-list/product-capture-list.component';
import { ProductCaptureRoutingModule } from './product-capture-routing.module';
import { ProductCaptureComponent } from './product-capture.component';
import { TerminateModalComponent } from './product-capture-list/terminate-modal/terminate-modal.component';

@NgModule({
  declarations: [
    ProductCaptureComponent,
    ProductCaptureListComponent,
    ProductCaptureDetailsComponent,
    CreateProductComponent,
    ProductSummaryComponent,
    PayoffComponent,
    SalesComponent,
    LegalFormComponent,
    AgentsComponent,
    OverviewComponent,
    AnalyticsComponent,
    WarningComponent,
    DocumentsComponent,
    KeyDatesModalComponent,
    PreviewModalComponent,
    DateRowComponent,
    ScheduleComponent,
    ScheduleRowComponent,
    DocumentsTabComponent,
    DocumentMenuComponent,
    UploadModalComponent,
    RequestModalComponent,
    AnalyticsRequestModalComponent,
    CompareModalComponent,
    DocumentComparisonComponent,
    CreditProvisionComponent,
    RecordWorkflowModalComponent,
    SaveButtonLabelPipe,
    FilterContactsPipe,
    FilterEntitiesPipe,
    IncrementalErrorMessagePipe,
    SettlementMethodComponent,
    EventSchedulesComponent,
    KeyDatesDataComponent,
    ToggleColumnValidationPipe,
    IsDirtyPipe,
    GovernanceChecksComponent,
    GovernanceTestResultsComponent,
    RefreshAnalyticsModalComponent,
    BarrierLevelPipe,
    RedemptionAmountPipe,
    FilterSourcePipe,
    ImportProductComponent,
    AuditModalComponent,
    DynamicStrikeLabelPipe,
    ProductNotesComponent,
    DocumentTypePipe,
    AnalyticsTablesBaseComponent,
    StressTestingTablesComponent,
    PriipsTablesComponent,
    AnalyticsReportStateComponent,
    RollDaysModalComponent,
    RollDaysModalRowComponent,
    CouponScheduleComponent,
    CallScheduleComponent,
    ParticipationScheduleComponent,
    PricingComponent,
    TerminateModalComponent,
  ],
  imports: [
    CommonModule,
    NgbModule,
    ProductCaptureRoutingModule,
    UiKitModule,
    FormsModule,
    FontAwesomeModule,
    ReactiveFormsModule,
    UnderlyingAssetsModalModule,
    ReferenceModalModule,
    SharedModule,
    NgxDocViewerModule,
  ],
  providers: [
    FormConfigService,
    AuditModalService,
    RoundAndFormatPipe,
    DateToStringPipe,
  ],
})
export class ProductCaptureModule {}
